import React, { Component } from 'react'
import "./App.css";
import { BrowserRouter,Switch, Route } from 'react-router-dom'
import Navbar from './components/layout/NavigationBar'
import Dashboard from './components/dashboard/Dashboard'
import UpdateMachine from './components/machines/UpdateMachine'
import SignIn from './components/auth/SignIn'
import AddMachine from './components/machines/AddMachine'
import SignUpPage from './components/layout/SignUpPage'
import ViewAllMachines from './components/machines/ViewAllMachines'


class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div>
          <Navbar />
          <Switch>
            <Route exact path="/" component={Dashboard} />
            <Route path="/machine/:id" component={UpdateMachine} />
            {/* <Route path="/signin" component={SignIn} /> */}
            <Route path="/signup" component={SignUpPage} />
            <Route path="/addmachine" component={AddMachine} />
            <Route path="/allmachines" component={ViewAllMachines} />
          </Switch>
        </div>
      </BrowserRouter>
    )
  }
}

export default App;
